var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6704 2.15131C15.4859 1.46598 14.9456 0.925618 14.2602 0.741105C13.0082 0.398438 7.99997 0.398438 7.99997 0.398438C7.99997 0.398438 2.99175 0.398438 1.7397 0.727925C1.06754 0.912439 0.514001 1.46598 0.329488 2.15131C0 3.40337 0 5.99973 0 5.99973C0 5.99973 0 8.60927 0.329488 9.84815C0.514001 10.5335 1.05436 11.0738 1.7397 11.2584C3.00493 11.601 7.99997 11.601 7.99997 11.601C7.99997 11.601 13.0082 11.601 14.2602 11.2715C14.9456 11.087 15.4859 10.5467 15.6704 9.86133C15.9999 8.60927 15.9999 6.01291 15.9999 6.01291C15.9999 6.01291 16.0131 3.40337 15.6704 2.15131Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40527 8.39891L10.57 6.00023L6.40527 3.60156V8.39891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.eb6973c499f8391d882250f1d74e1a15.svg";
export { ForwardRef as ReactComponent };